<template>
  <div class="leaderboard panel-settings">
  </div>
</template>

<script>
export default {
};
</script>
